function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlack = function SvgSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M122.643 316.682c0 26.596-21.727 48.323-48.321 48.323s-48.319-21.728-48.319-48.323c0-26.592 21.727-48.318 48.319-48.318h48.321zM146.996 316.682c0-26.592 21.728-48.318 48.321-48.318s48.32 21.727 48.32 48.318V437.68c0 26.592-21.728 48.319-48.32 48.319-26.594 0-48.321-21.728-48.321-48.319z",
    style: {
      fill: "#e01e5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.317 122.643c-26.594 0-48.321-21.728-48.321-48.321s21.728-48.32 48.321-48.32 48.32 21.728 48.32 48.32v48.321zM195.317 146.997c26.593 0 48.32 21.727 48.32 48.321s-21.728 48.318-48.32 48.318H74.321c-26.593 0-48.319-21.726-48.319-48.318 0-26.595 21.727-48.321 48.319-48.321z",
    style: {
      fill: "#36c5f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.359 195.318c0-26.595 21.725-48.321 48.32-48.321 26.593 0 48.318 21.727 48.318 48.321s-21.726 48.318-48.318 48.318h-48.32zM365.004 195.318c0 26.593-21.728 48.318-48.321 48.318s-48.32-21.726-48.32-48.318V74.321c0-26.593 21.728-48.32 48.32-48.32 26.594 0 48.321 21.728 48.321 48.32z",
    style: {
      fill: "#2eb67d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.683 389.358c26.594 0 48.321 21.727 48.321 48.321 0 26.592-21.728 48.319-48.321 48.319s-48.32-21.728-48.32-48.319v-48.321zM316.683 365.005c-26.593 0-48.32-21.728-48.32-48.323 0-26.592 21.728-48.318 48.32-48.318H437.68c26.593 0 48.318 21.727 48.318 48.318 0 26.596-21.726 48.323-48.318 48.323z",
    style: {
      fill: "#ecb22e"
    }
  }));
};
export default SvgSlack;